import {
  ClassItem,
  ClassGroupItem,
  MarkupType,
  ObjectItem,
  ObjectType,
  Source,
  Storage,
  Tag,
} from "../../models";
import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { DatasetStateInterface } from "./state";

const getters: GetterTree<DatasetStateInterface, StateInterface> = {
  getObjectItems(context): ObjectItem[] {
    return context.objectItems.filter(() => true);
  },
  getObjectTypes(context): ObjectType[] {
    return context.objectTypes.filter(() => true);
  },
  getStorages(context): Storage[] {
    return context.storages.filter(() => true);
  },
  getSources(context): Source[] {
    return context.sources.filter(() => true);
  },
  getMarkupTypes(context): MarkupType[] {
    return context.markupTypes.filter(() => true);
  },
  getTags(context): Tag[] {
    return context.tags.filter(() => true);
  },
  getClasses(context): ClassItem[] {
    return context.classes.filter(() => true);
  },
  getClassGroups(context): ClassGroupItem[] {
    return context.classGroups.filter(() => true);
  },
};

export default getters;
